import GoogleMapReact from "google-map-react";
import React, { useEffect, useState } from "react";
import _ from "lodash";

import { MapMarkerIcon } from "../../icons/mapMarker";
import { LA_CENTER } from "../../utils/googleMap";

function AddressEditMap({ location, onChange }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [mapCenter, setMapCenter] = useState<any>({});
  const [markerLocation, setMarkerLocation] = useState({});

  useEffect(() => {
    setMarkerLocation(location);
    setMapCenter(location || LA_CENTER);
  }, [location]);

  const onDrag = ({ center }) => {
    setMarkerLocation({
      lat: center.lat(),
      lng: center.lng(),
    });
  };

  const onMapChange = () => {
    if (_.isEqual(location, markerLocation)) {
      return;
    }

    onChange({ ...markerLocation });
  };

  return (
    <GoogleMapReact
      defaultCenter={LA_CENTER}
      center={mapCenter}
      zoom={17}
      yesIWantToUseGoogleMapApiInternals
      onChange={onMapChange}
      onDrag={onDrag}
    >
      <MapMarkerIcon {...markerLocation} />
    </GoogleMapReact>
  );
}

export { AddressEditMap };
